
/* ADMIN */
export const GET_ADMIN_LISTING = "GET_ADMIN_LISTING";
export const GET_ADMIN_LISTING_SUCCESS = "GET_ADMIN_LISTING_SUCCESS";
export const GET_ADMIN_LISTING_FAIL = "GET_ADMIN_LISTING_FAIL";

export const GET_ADMIN_DETAILS = "GET_ADMIN_DETAILS";
export const GET_ADMIN_DETAILS_SUCCESS = "GET_ADMIN_DETAILS_SUCCESS";
export const GET_ADMIN_DETAILS_FAIL = "GET_ADMIN_DETAILS_FAIL";

export const ADD_ADMIN = "ADD_ADMIN";
export const ADD_ADMIN_SUCCESS = "ADD_ADMIN_SUCCESS";
export const ADD_ADMIN_FAIL = "ADD_ADMIN_FAIL";

export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_FAIL = "UPDATE_ADMIN_FAIL";

export const UPDATE_ADMIN_PASSWORD = "UPDATE_ADMIN_PASSWORD";
export const UPDATE_ADMIN_PASSWORD_SUCCESS = "UPDATE_ADMIN_PASSWORD_SUCCESS";
export const UPDATE_ADMIN_PASSWORD_FAIL = "UPDATE_ADMIN_PASSWORD_FAIL";

export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAIL = "DELETE_ADMIN_FAIL";

export const EXPORT_ADMIN = "EXPORT_ADMIN";
export const EXPORT_ADMIN_SUCCESS = "EXPORT_ADMIN_SUCCESS";
export const EXPORT_ADMIN_FAIL = "EXPORT_ADMIN_FAIL";

export const RESET_ADMIN_STATE = 'RESET_ADMIN_STATE';
export const RESET_ADMIN_ACTION_STATE = 'RESET_ADMIN_ACTION_STATE';